import {useEffect, useRef} from 'react'

const useKeyPress = (
  onKeyPress: (event: KeyboardEvent) => void,
  key?: string,
  isEnabled = true
) => {
  const handler = useRef<(event: KeyboardEvent) => void>()
  const keyPressCallback = useRef<(event: KeyboardEvent) => void>()
  keyPressCallback.current = onKeyPress

  useEffect(() => {
    if (handler.current) {
      window.removeEventListener('keydown', handler.current, false)
    }

    if (isEnabled) {
      handler.current = event => {
        if (keyPressCallback.current && (event.key === key || !key)) {
          keyPressCallback.current(event)
        }
      }

      window.addEventListener('keydown', handler.current, false)
    }

    return () => {
      if (handler.current) {
        window.removeEventListener('keydown', handler.current, false)
      }
    }
  }, [key, isEnabled])
}

export default useKeyPress
